import { stagingEnvironmentConfig } from "./environment.staging";
import { productionEnvironmentConfig } from "./environment.live";
import { immotechEnvironmentConfig } from "./environment.immotech";
import { devEnvironmentConfig } from "./environment.development";
import { stagingAwsConfig } from "./aws/aws-exports.staging";
import { liveAwsConfig } from "./aws/aws-exports.live";
import { devAwsConfig } from "./aws/aws-exports.development";
import { immotechAwsConfig } from "./aws/aws-exports.immotech";

const stage = process.env.REACT_APP_STAGE;

export const config = stage === "develop"
  ? devEnvironmentConfig
  : stage === "staging"
  ? stagingEnvironmentConfig
  : stage === "live"
  ? productionEnvironmentConfig
  : stage === "immotech"
  ? immotechEnvironmentConfig
  : productionEnvironmentConfig;

export const awsConfig =
  stage === "develop"
    ? devAwsConfig
    : stage === "staging"
    ? stagingAwsConfig
    : stage === "live"
    ? liveAwsConfig
    : stage === "immotech"
    ? immotechAwsConfig
    : liveAwsConfig;
